import { Navigate, Outlet } from 'react-router-dom'

import { Box, Spinner } from '@factorialco/deprecated-design-system'
import { BenefitsActiveGuardPageDocument } from 'generated/resources/graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'

const BenefitsGuardPage = () => {
  const { data, error, loading } = useQuery(BenefitsActiveGuardPageDocument)

  const { navigation } = useNavigation()

  const isBenefitsSetupActive = error ? false : data?.benefits._policies.benefitsActive.can

  if (loading)
    return (
      <Box gap="s8" padding="s48" alignItems="center" data-testid="benefits-root-page-loading">
        <Spinner size="s32" />
      </Box>
    )

  return isBenefitsSetupActive ? (
    <Outlet />
  ) : (
    <Navigate to={navigation.benefits.landing.fullPath()} replace />
  )
}

export default BenefitsGuardPage
